import { compose, Dispatch, Middleware } from "redux";
import { ApplicationStore } from "src/store";
import { getDealPersonSuccess, getDealSuccess } from "src/store/actions/deal";
import { toggleModal } from "src/store/actions/openModal";
import {
    deleteVehicleFailure,
    deleteVehicleRequest,
    postVehicleFailure,
    postVehicleSuccess,
} from "src/store/actions/vehicles";
import { CLEAR_ALL, CLEAR_ALL_EXCEPT_ACCOUNT, UPDATE_AUTH } from "src/store/constants";
import { AccountResponses } from "src/store/dataService/types";
import { ApiVehicle } from "Types/api/Vehicle";

const createDynamicGarageReporters = () => {
    let garageReporters: Middleware[] = [];
    let store: any;

    const enhancer = (_store: any) => {
        store = _store;
        return (next: Dispatch) => (action: any) => {
            // @ts-ignore
            return compose(...garageReporters)(next)(action);
        };
    };

    const addReporter = (reporter: (vehicles: ApiVehicle[], os: any) => void) => {
        const middleware = (_store: any) => (next: Dispatch) => (action: any) => {
            next(action);

            if (
                typeof action !== "function" &&
                [
                    toggleModal.type,
                    CLEAR_ALL,
                    CLEAR_ALL_EXCEPT_ACCOUNT,
                    UPDATE_AUTH,
                    AccountResponses.GetSuccess,
                    postVehicleSuccess.type,
                    postVehicleFailure.type,
                    deleteVehicleRequest.type,
                    deleteVehicleFailure.type,
                    getDealPersonSuccess.type,
                    getDealSuccess.type,
                ].includes(action.type.toString())
            ) {
                const currentStore: ApplicationStore = _store.getState();

                reporter(
                    !currentStore.onlineShopper.isAuthed
                        ? []
                        : currentStore.vehicles.order
                              .map((vin) => currentStore.vehicles.entities[vin])
                              .filter((vehicle) => vehicle.isDeleting !== true) || [],
                    {
                        displayName: currentStore.deal?.person?.first_name || null,
                        isAuthenticated: currentStore.onlineShopper.isAuthed,
                        isAppOpen: currentStore.onlineShopper.isAppOpen,
                        action: action.type.toString(),
                    }
                );
            }
        };

        // @ts-ignore
        garageReporters.push(middleware(store));
    };

    const resetReporters = () => {
        garageReporters = [];
    };

    return {
        enhancer,
        addReporter,
        resetReporters,
    };
};

const dynamicGarageReporters = createDynamicGarageReporters();

export default dynamicGarageReporters.enhancer;

export const { addReporter: addGarageReporter, resetReporters: resetGarageReporters } = dynamicGarageReporters;
